import { SsrDetails } from '@tff/types/tff/tfa-amend-ancillary-service';

/*
  this functionality is to merge 'additional luggages" into an one object
  and sum their amounts. Since luggages can be chosen multiple times for each
  passenger, this approach is required. 
*/
export const mergeBXObjects = (arr: SsrDetails[]) => {
  const result: SsrDetails[] = [];
  const bxMap = {} as SsrDetails;

  arr.forEach(item => {
    const { code, amount, segmentOnd } = item;
    if (code.includes('BX')) {
      const key = `${segmentOnd}-${code}`;
      if (bxMap[key]) {
        bxMap[key].amount += amount;
      } else {
        bxMap[key] = {...item};
      }
    } else {
      result.push(item);
    }
  });

  Object.values(bxMap).forEach(bxItem => result.push(bxItem));

  return result;
};
